const sendSearchRequest = require('./sendSearchRequest');
const replaceResults = require('../model/replaceResults');
const {
    submitEventListener,
    textInputPresenter,
} = require('gui');

module.exports = function searchPresenter(model) {
    const view = require('./searchPresenter.tpl.html');
    var c = {};
    var searchInputPresenter = textInputPresenter({
        model: model.search.text,
        icon: 'fa-search',
        placeholderText: '',
        iconRight: true,
        onIconClicked: onSubmit,
    });

    var submitListener = submitEventListener();

    c.activate = function(region) {
        view.activate(region);
        searchInputPresenter.activate(view.searchInputRegion);
        submitListener.add(view.searchInputRegion, onSubmit);

        var text = model.search.text();
        if(text && text.length > 0)
            search();
    };

    function onSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        searchInputPresenter.blur();
        setTimeout(() => search(), 100);
    }

    function search() {
        model.isSearching(true);
        sendSearchRequest(model.search.text(), model.search.type())
            .then(negotiateResults)
            .then(updateModel, updateModel);
    }

    function negotiateResults(firstResult) {
        const result = firstResult.filter(dto => dto.Found !== undefined);
        if (result.length > 0)
            return replaceResults(firstResult, model.results);

        return sendSearchRequest(model.search.text(), 'sendersReference')
            .then(dtos => replaceResults(dtos, model.results));
    }

    function updateModel() {
        model.isSearching(false);
        model.hasSearched(true);
    }

    c.deactivate = function() {
        submitListener.remove(view.searchInputRegion, onSubmit);
        searchInputPresenter.deactivate();
        view.deactivate();
    }
    return c;
}
